import { CHECKOUT_HOST_MESSAGE_SOURCE } from './reportFrameHeight';

/** El host (checkout web) avisa que la sesión se invalidó (logout, vencida o rechazada). */
export const HOST_SESSION_RESET_MESSAGE = 'session-reset';

const isEmbeddedInHost = (): boolean => {
  try {
    return window.parent !== window;
  } catch {
    return true;
  }
};

/** Mismo criterio que `submit` y `layout`: solo el parent directo, con el source del checkout web. */
export const listenForHostSessionReset = (onReset: () => void): (() => void) => {
  if (!isEmbeddedInHost()) return () => undefined;
  const handler = (event: MessageEvent) => {
    if (event.source !== window.parent) return;
    const data = event.data as { source?: string; type?: string } | null;
    if (!data || data.source !== CHECKOUT_HOST_MESSAGE_SOURCE || data.type !== HOST_SESSION_RESET_MESSAGE) {
      return;
    }
    onReset();
  };
  window.addEventListener('message', handler);
  return () => window.removeEventListener('message', handler);
};
